// Calendar grid generation — Monday-first 7-column layout.
// No external date library.

import { localDateString } from "./calendarCodec";
import { parseYearMonth, daysInMonth } from "./calendarMonth";

// Returns 0=Mon, 1=Tue, ..., 5=Sat, 6=Sun from JS getDay() (0=Sun, 1=Mon,...,6=Sat)
function jsWeekdayToMondayFirst(jsWeekday) {
  return (jsWeekday + 6) % 7;
}

/**
 * Build a flat array of calendar cells for the month.
 * Each cell: { dateStr: "YYYY-MM-DD" | null, isCurrentMonth: boolean }
 * Adjacent-month cells have dateStr = null (visually muted, no events).
 */
export function buildCalendarGrid(month) {
  const { year, month: m } = parseYearMonth(month);
  const numDays = daysInMonth(month);

  // Monday-first weekday of the 1st
  const firstDay = new Date(year, m - 1, 1);
  const startOffset = jsWeekdayToMondayFirst(firstDay.getDay());

  // Total cells must be a multiple of 7 and cover the full month
  const totalCells = Math.ceil((startOffset + numDays) / 7) * 7;

  const cells = [];

  for (let i = 0; i < totalCells; i++) {
    const dayOfMonth = i - startOffset + 1; // 1..numDays for current month
    if (dayOfMonth < 1 || dayOfMonth > numDays) {
      // Adjacent-month cell — null dateStr, do not show task events
      cells.push({ dateStr: null, isCurrentMonth: false });
    } else {
      const d = new Date(year, m - 1, dayOfMonth);
      cells.push({ dateStr: localDateString(d), isCurrentMonth: true });
    }
  }

  return cells;
}

export const WEEKDAY_HEADERS = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Нд"];
